module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak kajakowy.svg?4c6482ef";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak kajakowy.svg
// module id = 2009
// module chunks = 0